/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Hide_ValueInputs */

const en_tables_custom_properties_hide_value = /** @type {(inputs: Tables_Custom_Properties_Hide_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Hide Value`)
};

const de_tables_custom_properties_hide_value = /** @type {(inputs: Tables_Custom_Properties_Hide_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert ausblenden`)
};

/**
* | output |
* | --- |
* | "Properties Hide Value" |
*
* @param {Tables_Custom_Properties_Hide_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_hide_value = /** @type {((inputs?: Tables_Custom_Properties_Hide_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Hide_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_hide_value(inputs)
	return de_tables_custom_properties_hide_value(inputs)
});